import React, { useState, useEffect } from 'react';
import { api } from './api/models';
import Login from './components/Login';
import Editor from './components/Editor';
import './App.css';

function App() {
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        api.checkStatus().then(data => setIsAuthenticated(data.authenticated));
    }, []);

    if (!isAuthenticated) {
        return <Login onLoginSuccess={() => setIsAuthenticated(true)} />;
    }

    return <Editor />;
}

export default App;